<template>
<v-layout align-center justify-center>
  <v-flex xs12 sm8 >
<v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
              <v-icon>person</v-icon>
                <v-toolbar-title class="ml-2">User Login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    v-model="user"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
  </v-flex>
</v-layout>
 
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data: () =>({
        user: null,
        password: null,
    }),
  
    methods: {
      ...mapActions({
        get_login: 'login/fetchUser' 
      }),
      login () {
        this.get_login({ user: this.user,
                          password: this.password
                      })
        //console.log(this.$store.state.login.user)
      }
    }
}
</script>

<style>

</style>
